module.exports = __webpack_public_path__ + "img/H5.b9548b19.png";